import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowBarRight = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsxs("g", {
		id: "icon/hardware/keyboard_tab_24px",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "icon/hardware/keyboard_tab_24px_2",
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M15.67 11L12.09 7.41L13.5 6L19.5 12L13.5 18L12.08 16.59L15.67 13H1.5V11H15.67ZM22.5 18H20.5V6H22.5V18Z",
				fill: "#2771bb"
			}),
			/* @__PURE__ */ _jsx("mask", {
				id: "mask0",
				"mask-type": "alpha",
				maskUnits: "userSpaceOnUse",
				x: 1,
				y: 6,
				width: 24,
				height: 12,
				children: /* @__PURE__ */ _jsx("path", {
					id: "icon/hardware/keyboard_tab_24px_3",
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M15.67 11L12.09 7.41L13.5 6L19.5 12L13.5 18L12.08 16.59L15.67 13H1.5V11H15.67ZM22.5 18H20.5V6H22.5V18Z",
					fill: "white"
				})
			}),
			/* @__PURE__ */ _jsx("g", { mask: "url(#mask0)" })
		]
	})]
});
const ForwardRef = forwardRef(SvgArrowBarRight);
export default ForwardRef;
